import { z } from 'zod';

import { createZodStringParser } from '@Common/types/zod/zod-parse-string';

export const ZodNumberQuery = createZodStringParser(z.number(), z.string().pipe(z.coerce.number()));

export const ZodOffsetQuery = createZodStringParser(
  z.number().min(0),
  z.string().pipe(z.coerce.number()),
);

export const ZodLimitQuery = createZodStringParser(
  z.number().positive(),
  z.string().pipe(z.coerce.number()),
);
